function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 373;


//////////////////
// WEBPACK FOOTER
// ./src/collections nonrecursive \.js$
// module id = 373
// module chunks = 0